<template>

<v-row class="ma-0 pa-0 fst-block-home" >  
  <v-col cols="12" class="pa-0" >
<v-card tile flat dark class="top-menu-home ma-0" >

    <v-row class="px-0 ma-0 mt-1 logo-w" justify="center" align="center" v-if="$vuetify.breakpoint.xs"  >
    <v-col cols="7" :class="{'hide-logo':drawer}" @click="goToHomePage">
        <v-img src="../assets/logo-gagarin-wt.svg" aspect-ratio="4" contain ></v-img>
    </v-col>

                  <v-col class="pa-0 ma-0  " cols="5">
                    <v-row class="ma-0 pa-0 white--text  point-cursor" justify="space-between" align="center"  @click="goToPageC('/contacts')">
                      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0 mr-2 d-flex  justify-end">
                        <v-icon small>mdi-clock</v-icon> <span class="topmnu-btn-xs pl-2 pt-1"  > {{dataAdmin.settings.clocks}}</span> 
                      </v-col>

                    </v-row>
                    <v-row class="ma-0 px-0 py-1 white--text  point-cursor" justify="space-between" align="center"  @click="goToPageC('/contacts')">
                      <v-col cols="12" sm="12" md="12" lg="12" xl="12"  class="py-0 mr-2 d-flex  justify-end">
                        <v-icon small>mdi-map-marker</v-icon> <span class="topmnu-btn-xs pl-2 pt-1"  >{{dataAdmin.settings.contacts}}</span> 
                      </v-col>
                    </v-row>
                  </v-col>    
    </v-row>
<!--     <v-row class="pl-5 pr-0 ma-0  logo-w" justify="center" align="center" v-if="$vuetify.breakpoint.xs"  >
                  <v-col class="pa-0 ma-0  " cols="2" @click="goToPage('/#')">
                    <v-icon >mdi-store</v-icon>
                  </v-col>    
                  <v-col class="pa-0 ma-0  " cols="2" @click="goToPage('/#')">
                    <v-icon >mdi-coffee</v-icon>
                  </v-col>    
                  <v-col class="pa-0 ma-0  " cols="2" @click="goToPage('/#')">
                    <v-icon >mdi-sparkles</v-icon>
                  </v-col>    
                  <v-col class="pa-0 ma-0  " cols="2" @click="goToPage('/#')">
                    <v-icon >mdi-room-service</v-icon>
                  </v-col>    
                  <v-col class="pa-0 ma-0  " cols="2" @click="goToPage('/#')">
                    <v-icon >mdi-magnify</v-icon>
                  </v-col>    
    </v-row> -->
<v-row class="ma-0 pa-0">
  <v-col cols="12" class="pa-0 ma-0">
    <TopFullMenuMob v-if="pathHome && $vuetify.breakpoint.xs"/>
  </v-col>
</v-row>
  <v-row class="pa-0 ma-0 find-mob-home theme--light"  justify="center" align="center" v-if="pathHome && $vuetify.breakpoint.xs && isViewFind">
    <v-col class="pa-0 mr-3 mt-3" cols="10">
        <FindShopMob colorF="black" :themeF="true"/>
    </v-col>
  </v-row>
<v-row class="ma-0 pa-0 burger-mob" justify="start" align="center" v-if="$vuetify.breakpoint.xs">
  <v-col cols="2" class="pa-0">
      <v-app-bar-nav-icon v-if="pathHome " @click.stop="drawer = !drawer" ></v-app-bar-nav-icon>
  </v-col>
</v-row>

<v-row class="pa-0 ma-0" justify="end" align="center" v-if="$vuetify.breakpoint.smAndUp">
  <v-col cols="2" sm="4" md="3" lg="2" xl="2" class="py-0">
    <div v-if="pathHome && $vuetify.breakpoint.xs" class="empty-right"></div>
      <v-app-bar-nav-icon v-if="!pathHome && $vuetify.breakpoint.xs" @click.stop="drawer = !drawer" class="mr-0">  </v-app-bar-nav-icon>
    <div class="pa-0 logo-w  " v-if="$vuetify.breakpoint.smAndUp" @click="goToHomePage">
    <img  class="w-logo ml-0 d-flex justify-start" src="../assets/logo-gagarin-wt.svg"  v-if="!drawer && darkTheme" transition="slide-x-transition" reverse-transition="slide-x-reverse-transition"/>
    <img  class="w-logo ml-0" src="../assets/logo-gagarin-wt.svg"  v-if="!drawer && !darkTheme" transition="slide-x-transition" reverse-transition="slide-x-reverse-transition"/>    
    </div>  
  </v-col>
  <v-col cols="12" sm="4" md="6" lg="8" xl="8" class="pa-0">
      <div style="width:100%"></div>
  </v-col>
  <v-col cols="2" sm="4" md="3" lg="2" xl="2" class="px-0 ">



<v-row class="pa-0 ma-0">
                  <v-col class="pa-0 ma-0  " cols="12">
                    <v-row class="ma-0 pa-0 white--text  point-cursor" justify="space-between" align="center" v-if="$vuetify.breakpoint.smAndUp" @click="goToPageC('/contacts')">
                      <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0 mr-2 d-flex  justify-end">
                        <v-icon>mdi-clock</v-icon> <span class="topmnu-btn pl-2 pt-1" :class="[{'body-1': $vuetify.breakpoint.sm},{'contact-info-md': $vuetify.breakpoint.md},{'contact-info-lg': $vuetify.breakpoint.lg}]" > {{dataAdmin.settings.clocks}}</span> 
                      </v-col>

                    </v-row>
                    <v-row class="ma-0 px-0 py-1 white--text  point-cursor" justify="space-between" align="center" v-if="$vuetify.breakpoint.smAndUp" @click="goToPageC('/contacts')">
                      <v-col cols="12" sm="12" md="12" lg="12" xl="12"  class="py-0 mr-2 d-flex  justify-end">
                        <v-icon>mdi-map-marker</v-icon> <span class="topmnu-btn pl-2 pt-1" :class="[{'body-1': $vuetify.breakpoint.sm},{'contact-info-md': $vuetify.breakpoint.md},{'contact-info-lg': $vuetify.breakpoint.lg}]" >{{dataAdmin.settings.contacts}}</span> 
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
  </v-col>
</v-row>





      
        <v-row justify="space-between" align="end" class="pt-0 ma-0"  v-if="$vuetify.breakpoint.smAndUp">
          <v-col cols="2"  class="pa-0 ">
            <v-row justify="start" align="end" class="pt-0 ma-0">
              <v-col cols="12" class="pa-0 ">

                <v-btn icon v-if="!pathHome && $vuetify.breakpoint.xs" @click="backPath">
                {{$router.path}}
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-app-bar-nav-icon v-if="pathHome  && $vuetify.breakpoint.xs" @click.stop="drawer = !drawer" ></v-app-bar-nav-icon> 
            <v-row  justify="start" align="end" class="ma-0 pa-0">  
 
              <v-col cols="12" class="pa-0 mx-0 mb-4">
                    <v-btn class="ml-3 pa-0 mbtpx  subtitle-1 d-flex align-end" tile text small color="white"  v-show="pathHome &&  $vuetify.breakpoint.smAndUp && !drawer" @click.stop="drawer = !drawer" >
                      <v-icon size="22">mdi-menu</v-icon> МЕНЮ
                    </v-btn>
              </v-col> 
              </v-row>
                  </v-col>
            </v-row>

              </v-col>
                <v-col cols="8" class="pa-0">
                  <v-row justify="center" align="end">
                    <v-col class="pa-0 mb-4">
                      <TopFullMenu v-if="pathHome && $vuetify.breakpoint.smAndUp"/>
                    </v-col>
                  </v-row>                  
                </v-col>            
              <v-col cols="2" class="pa-0">
                <v-row class="pa-0 ma-0" justify="end" align="end">
                  <v-col class="pa-0 mr-3" cols="12">
                      <FindShop />
                  </v-col>
                </v-row>
              </v-col>          
        </v-row>      

      
<!-- :width="$vuetify.breakpoint.xs?'80%':'18%'" -->

<!-- ====================================== DRAWER =========================================== -->
    <v-navigation-drawer
      fixed
      v-model="drawer"
      temporary
      hide-overlay
      left
      app      
      :width="widthDrawer"
      color="rgba(0,0,0,0.6)"
      dark
      @transitionend="endTrans"
      class="bg-drawer"
    >
    <!-- <div class="px-5 "  v-if="$vuetify.breakpoint.smAndUp"> -->
    <div class="px-5 "  v-if="$vuetify.breakpoint.smAndUp">
      <v-img src="../assets/logo-gagarin.svg" aspect-ratio="4.0" contain class="w-logo mt-4"></v-img>
    </div>
    <div class="px-5 "  v-if="$vuetify.breakpoint.xs">
      <v-img src="../assets/logo-gagarin.svg" aspect-ratio="4.0" contain class="w-logo mt-4"></v-img>
    </div>
    

              <v-row  justify="start" align="center" class=" mt-xs-2 mx-0"> 
              <v-col cols="1" class="py-0 ma-0">
                    <v-btn class="my-0" icon dark color="white"  v-show="pathHome  && drawer" @click.stop="drawer = !drawer" >
                      <v-icon >mdi-close</v-icon>
                    </v-btn>
              </v-col> 
              </v-row>
      <v-list dense >
        <span :key="`mnu-`+i" v-for="(itm, i) in drawerMenuHome">
                <v-list-item link  @click='goToPage(itm)'>


                  <v-list-item-content>
                    <v-list-item class="text-left title">{{itm.title}}</v-list-item>
                  </v-list-item-content>
                </v-list-item>

        </span>
      </v-list>

    </v-navigation-drawer>
</v-card>
<SSlide />

<!-- ============================ NEWS ====================================== -->

        <v-row class="center mx-0 pa-0 d-flex align-content-space-between" :style="`background-image: url(`+homeNewsBG+`)`" :class="[isMobile ? 'home-news-bg-mob' : 'home-news-bg height-screen']" id="target-news" >

          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
            xl="12"
            class="pt-0 pb-0 "            
          >
          <div class="white--text display-1 mt-6">
            НОВОСТИ
          </div>

  <v-row 
  v-if="isNewsLoad"
  align="center"
  justify="center"
  class="ma-0 pa-0"
    >
    <v-col cols="12" sm="12" md="8" lg="8" xl="8" >

          <v-row justify="center" align="center">
            <v-col
              v-for="n in news.length > 8? 8: news.length"
              :key="n"
              class="py-4"              
               cols="6" sm="4" md="4" lg="3" xl="3"
            >
              <NewsBlock :newsFilter="news[n-1]" size="sml"/>


            </v-col>
          </v-row>
    
    </v-col>
  </v-row>

 

          </v-col>


        <v-col class="d-flex align-content-end justify-center flex-column">
                  <v-row class=" ma-0 pa-0 " >
                              <v-col cols="12" class="pa-0">
                              <div class="mb-8"> 
                                <span @click="gotoAllNews" class="mx-2  pa-2 subtitle-1 btn-mnu cursor-url white--text">ВСЕ НОВОСТИ</span>
                              
                              </div>
                              <!-- <div  v-if="$vuetify.breakpoint.smAndUp"> -->
                              <div>
                                  <v-btn 
                                  class="ma-2 btn-round-border-w" 
                                  fab
                                  outlined
                                  x-large                            
                                  color="#fff"
                                  @click="$vuetify.goTo(target[1], options[1])"
                                  >
                                    <v-icon light>mdi-chevron-down</v-icon>
                                  </v-btn>
                                </div>
                                </v-col>

                  </v-row> 
        </v-col>

        </v-row>


        <v-row class="center mx-0 pa-0 home-section-contacts" id="target-map" v-if="$vuetify.breakpoint.smAndUp">              
            <v-col cols="12"  lg="4" xl="4" sm="6" md="6" class="grey darken-4 white--text px-0 bg-contacts-off col-fade">            
              <v-list  dark  class="text-left ml-0 px-1 transparent">
                <v-list-item>
                  <v-list-item-content>
                    <div class="display-1 text-center mb-3">КОНТАКТЫ</div>                    
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>          
                    <v-list-item-subtitle>119334, г. Москва, ул. Вавилова, дом 3</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>          
                    <v-list-item-subtitle>Метро: Ленинский проспект, станция МЦК: Площадь Гагарина</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>          
                    <p>Телефон: <Phone :number= "`+7-915-083-48-80`" :dark="true" /> </p>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>                          
                    <v-list-item-subtitle>e-mail: <span class="text-underline"> <Email emailaddr= 'info@trcgagarinsky' :dark=true />  </span></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
<!--                 <v-list-item>
                  <v-list-item-content>          
                    <v-list-item-subtitle>Телефоны:  <span class="text-underline"> Магазины </span></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item> -->


              </v-list>
            </v-col>
            <v-col cols="12"   lg="8" xl="8" sm="6" md="6" class="ma-0 pa-0 grey darken-4" color="">                
              <YandexMap :heigtMap="'400px'" :viewRoute=true />
            </v-col>
            </v-row>

        <v-row class="center mx-0 pa-0 " id="target-map" v-if="$vuetify.breakpoint.xs">              
            <v-col cols="12"  lg="4" xl="4" sm="6" md="6" class="grey darken-4 white--text px-0 bg-contacts-off col-fade">            
              <v-list  dark  class="text-left ml-0 px-1 transparent">
                <v-list-item>
                  <v-list-item-content>
                    <div class="display-1 text-center mb-3">КОНТАКТЫ</div>                    
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>          
                    <v-list-item-subtitle>119334, г. Москва, ул. Вавилова, дом 3</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>          
                    <v-list-item-subtitle>Метро: Ленинский проспект, станция МЦК: Площадь гагарина</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>          
                    <p>Телефон: <Phone :number= "`+7-915-083-48-80`" :dark="true" /> </p>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>                          
                    <v-list-item-subtitle>e-mail: <span class="text-underline"> <Email emailaddr= 'info@trcgagarinsky' :dark=true />  </span></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
<!--                 <v-list-item>
                  <v-list-item-content>          
                    <v-list-item-subtitle>Телефоны:  <span class="text-underline"> Магазины </span></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item> -->


              </v-list>
            </v-col>
            <v-col cols="12"   lg="8" xl="8" sm="6" md="6" class="ma-0 pa-0 grey darken-4" color="">                
              <YandexMap :heigtMap="'400px'" :viewRoute=false />
            </v-col>
            </v-row>


<v-row class="ma-0 pa-0">
  <v-col class="pa-0">
    <FooterMob />
  </v-col>
</v-row>

<Footer />  
  </v-col>



  </v-row>



</template>

<script>
import Vue from 'vue'
import store from '../store'
import axios from "axios"
import router from 'vue-router'
import YandexMap from '@/components/YandexMap'

import SSlide from '@/components/Swiper'
import TopFullMenu from '@/components/TopFullMenu'
import TopFullMenuMob from '@/components/TopFullMenuMob'
import Footer from '@/components/Footer'
import FooterMob from '@/components/FooterMob'
import FindShop from '@/components/FindShop'
import FindShopMob from '@/components/FindShopMob'
import NewsBlock from '@/components/NewsBlock'
import Email from '@/components/Email'
import Phone from '@/components/Phone'

Vue.use(
  store,
  
)

export default {
  name: 'Home',
  components: {
    YandexMap,
    SSlide,
    TopFullMenu,
    TopFullMenuMob,
    Footer,
    FooterMob,
    FindShop,
    FindShopMob,
    NewsBlock,
    Email,
    Phone,
  },
 
      data () {
      return {

      topPosition:0,
        swiperOptions: {
          pagination: {
            el: '.swiper-pagination'
          },
          // Some Swiper option/callback...
        },

      slideN:0,
      length: 3,
      onboarding: 0,
      icons: [
        'mdi-facebook',
        'mdi-twitter',
        'mdi-linkedin',
        'mdi-instagram'
      ],
      iconsBar:[
        require('@/assets/icons/map-w.png'),
        require('@/assets/icons/map-color.png'),
        require('@/assets/icons/clock-w.png'),
        require('@/assets/icons/clock-color.png'),
        require('@/assets/icons/point-w.png'),
        require('@/assets/icons/point-color.png'),
      ],
      //homeNewsBG: require('@/assets/background/home-news-bg.jpg'),
      homeNewsBG: null,
      socialLinks:[
        {
        title: 'Facebook',
        link: '',
        icon: require('@/assets/smm_fb1.png')
        },
        {
        title: 'Instagramm',
        link: '',
        icon: require('@/assets/smm_insta1.png')
        },
        {
        title: 'Одноклассники',
        link: '',
        icon: require('@/assets/smm_ok1.png')
        },
        {
        title: 'Telegramm',
        link: '',
        icon: require('@/assets/smm_tel1.png')
        },
        {
        title: 'Twitter',
        link: '',
        icon: require('@/assets/smm_tw1.png')
        },
        {
        title: 'Вконтакте',
        link: '',
        icon: require('@/assets/smm_vk1.png')
        },
      ],
        colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
        ],
        selector: ['#target-news','#target-map'],
        selected: 'Button',
        duration: 600,
        offset: [0,0],
        options: [
          {
            duration: 600,
            offset: 0,
            easing: 'easeInOutCubic',
          },
          {
            duration: 600,
            offset: 0,
            easing: 'easeInOutCubic',
          },

        ],
        easing: 'easeInOutCubic',

        slides: [
          { 
            text:"ВЕСНА 2020",
            subtext:"Новые коллекции уже в магазинах ТРЦ Гагаринский",
            style:{
            color: '#fff',
            backgroundImage: "url("+require('@/assets/slider/slide01.jpg')+")",
            backgroundSize: 'cover',
            }
            },
         
          { 
            text:"LaserLand",
            subtext:"Центр внеземных развлечений",
            style:{
            color: '#fff',
            backgroundImage: "url("+require('@/assets/slider/slide02.jpg')+")",
            backgroundSize: 'cover',
            }
            },
         
          { 
            text:"Рестораны и Кафе",
            subtext:"Разнообразие на любой вкус",
            style:{
            color: '#fff',
            backgroundImage: "url("+require('@/assets/slider/slide03.jpg')+")",
            backgroundSize: 'cover',
            }
            },
          
        ],
      }
    },
        metaInfo: {
          title: 'Главная -',

        },

/*   methods: {

   
      shuffleArray(a) {
          let i, t, j;
          for (i = a.length - 1; i > 0; i -= 1) {
              t = a[i];
              j = Math.floor(Math.random() * (i + 1));
              a[i] = a[j];
              a[j] = t;
          }
          return a;
      },
      endTrans(){
      if(DEBUG) console.log( "            <<<<<<<<<<<< МЕНЮ ЗАКРЫЛОСЬ >>>>>>>>>>>>" )
      },
      next () {
        this.onboarding = this.onboarding + 1 === this.length
          ? 0
          : this.onboarding + 1
      },
      prev () {
        this.onboarding = this.onboarding - 1 < 0
          ? this.length - 1
          : this.onboarding - 1
      },

      loadPages(){      
      if(DEBUG) console.log(" *** -^--== Load News ==--^- *** ");
      let vApp = this;
      },
      gotoNews(nNews){
        let vApp = this;
        if(DEBUG) console.log('nNews :', vApp.news[nNews].titleAction);
        vApp.$router.push('/'+vApp.loadPathData.mnuNewsPath+'/'+vApp.news[nNews].id);
      },


      goToPage (itemMnu) {
        let vApp = this;
        vApp.drawer = false;
        setTimeout(function() {
          if (vApp.$route.path !== itemMnu.url){
            if(DEBUG) console.log(' gotoPAGE url :>> ', itemMnu.url)
            if(DEBUG) console.log(' gotoPAGE ID :>> ', itemMnu.id)
            if(itemMnu.id < 12) {
             vApp.$router.push(itemMnu.url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                  throw error
                }
              })
             
             }
             else{
               if(DEBUG) console.log('vApp.pages :>> ',vApp.pages)
              const getPageInfo = vApp.pages.find(fpi=>fpi.slug === itemMnu.url)
               
               if(DEBUG) console.log('GoTo Single Page :>> ',getPageInfo)
                            vApp.$router.push('/page/'+itemMnu.url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                  throw error
                }
              })
               
             }
             }

        }, 500);


      },

     }, */
  methods: {   
      shuffleArray(a) {
          let i, t, j;
          for (i = a.length - 1; i > 0; i -= 1) {
              t = a[i];
              j = Math.floor(Math.random() * (i + 1));
              a[i] = a[j];
              a[j] = t;
          }
          return a;
      },
      endTrans(){
      if(DEBUG) console.log( "            <<<<<<<<<<<< МЕНЮ ЗАКРЫЛОСЬ >>>>>>>>>>>>" )
      },
      next () {
        this.onboarding = this.onboarding + 1 === this.length
          ? 0
          : this.onboarding + 1
      },
      prev () {
        this.onboarding = this.onboarding - 1 < 0
          ? this.length - 1
          : this.onboarding - 1
      },

      loadPages(){      
      if(DEBUG) console.log(" *** -^--== Load News ==--^- *** ");
      let vApp = this;
      },
      gotoNews(nNews){
        let vApp = this;
        if(DEBUG) console.log('nNews :', vApp.news[nNews].titleAction);
        vApp.$router.push('/'+vApp.loadPathData.mnuNewsPath+'/'+vApp.news[nNews].id);
      },
      gotoAllNews(){
        let vApp = this;
        
        vApp.$router.push('/'+vApp.loadPathData.mnuNewsPath)
      },
      goToHomePage(){
        let vApp = this;
        
        vApp.$router.push('/')
      },
    goToPageC (url) {
      let vApp = this;
      vApp.drawer = false;
      if(DEBUG) console.log('url :>> ', url);
      vApp.$router.push(url).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    },

      goToPage (itemMnu) {
        let vApp = this;
        vApp.drawer = false;
        setTimeout(function() {
          if (vApp.$route.path !== itemMnu.url){
            if(DEBUG) console.log(' gotoPAGE url :>> ', itemMnu.url)
            if(DEBUG) console.log(' gotoPAGE ID :>> ', itemMnu.id)

            if(itemMnu.url == '/'){
              vApp.$router.push('/')
            }
            else{              
            if(itemMnu.id < 12) {
             vApp.$router.push('/'+itemMnu.url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                  throw error
                }
              })
             
             }
             else{
               if(DEBUG) console.log('vApp.pages :>> ',vApp.pages)
              const getPageInfo = vApp.pages.find(fpi=>fpi.slug === itemMnu.url)
               
               if(DEBUG) console.log('GoTo Single Page :>> ',getPageInfo)
                            vApp.$router.push('/page/'+itemMnu.url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                  throw error
                }
              })
               
             }
             }
             }

        }, 500);


      },

     },
  computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    widthDrawer(){
      const vApp = this;
        switch (vApp.$vuetify.breakpoint.name) {
          case 'xs': 
          return '100%';
          case 'sm': 
          return '55%';
          case 'md': 
          return '35%';
          case 'lg': 
          return '22%';
          case 'xl': 
          return '18%';

          default:
            break;
        }




    },

    dataAdmin:{
      get () {
        return this.$store.getters.getDataAdmin;
      },
     
    },    
    loadPathData: {
        get () {
            return this.$store.getters.getLoadPathData
          }          
        }, 
    allShops:{
      get () {
        return this.$store.state.shops.shops
      },
    },       
    pathHome(){
          return this.$route.path === '/'
      },
    isViewFind: {
      get() {
        return this.$store.state.app.isViewFind;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setIsViewFind", val);
      },
    },
    isMobile: {
      get () {
        return this.$store.state.app.isMobile
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('setIsMobile', val)
      }
    },
    drawer: {
      get () {
        return this.$store.state.menu.drawer
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('updateDrawer', val)
      }
    },
    pages: {
      get () {
        let vApp = this;
        return vApp.$store.state.pages.allPages;
      },

    },           
    drawerMenuHome: {
      get () {
        let vApp = this;
        return vApp.$store.state.menu.menuh;
      },

    },           
    drawerMenu: {
      get () {
        let vApp = this;       
        return vApp.$store.state.menu.menu;
      },
      set (val) {
        let vApp = this
        vApp.$store.dispatch('updateMenu', val)
      }
    },           
      darkTheme: {
        get () {
          return this.$store.state.app.darkTheme
        },
        set (value) {
          this.$store.dispatch('setTheme', value)
        }
      },
      news() {
        let vApp = this;
          if(DEBUG) console.log('news :', vApp.$store.state.news.news);
          let retFNews=vApp.shuffleArray(vApp.$store.state.news.news);
            return retFNews;
          },
      isNewsLoad() {
          if(DEBUG) console.log('isNewsLoad :', this.$store.state.news.isNewsLoad);
            return this.$store.state.news.isNewsLoad;
          },
      target () {
        const value = this.selector
        if (!isNaN(value)) return Number(value)
        else return value
      },

     },

  mounted () {    
    if(DEBUG) console.log('mounted Home = ');
    if(DEBUG) console.log('QUESTION = ',false || '' || undefined || 4 || true || 0);


    let vApp = this
    this.$nextTick(function () {
      

      let scrollEl = document.querySelector('#first');
      let targetEl = document.querySelector('#trig');
      scrollEl.scrollTo(0,0);
      scrollEl.addEventListener('scroll', function() {
        if(scrollEl.scrollTop<255){
        vApp.topPosition = scrollEl.scrollTop;
        if(DEBUG) console.log('scrollEl :', scrollEl.scrollTop );
        }
        else{
          vApp.topPosition = 255;
        }
      });


      let getHTML = document.documentElement;
      if(DEBUG) console.log('getHTML :', getHTML);
      getHTML.removeAttribute('style');
      if(DEBUG) console.log('this.$store Home :', vApp.$store)
         if(vApp.allShops === null){
        axios({
              method: "get",
              url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_all_shops/json"

            })
              .catch(function(error) {
                if(DEBUG) console.log("ERROR: ", error);
              })
              .then( function(response) {
                if(DEBUG) console.log("response dataAllShops =",response.data );
                vApp.$store.dispatch("loadShops",response.data);

                });

    }
    });
    if(vApp.dataAdmin !== null) {
    vApp.homeNewsBG = vApp.dataAdmin.fon_contacts
    }
  },
  beforeRouteEnter(to, from, next) {
        next(vm => {
          
          // экземпляр компонента доступен как `vm`
          if(DEBUG) console.log('Home vm :', vm);
        })
  },
  beforeDestroy: function () {
     if(DEBUG) console.log("Удаляем HOME");
  }      
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .example-slide {
    align-items: center;
    background-color: #666;
    color: #999;
    display: flex;
    font-size: 1.5rem;
    justify-content: center;
    min-height: 10rem;
  }


.home-section-contacts{

  height: 80vh;
}

.home-news-bg{
/* width: 1920px; */
height: 100vh;
/*background-image: url('../assets/background/home-news-bg.jpg');*/
background-size: cover;
background-position: center;
background-repeat: no-repeat;

}
.home-news-bg-mob{
/* width: 1920px; 
height: 100vh;*/
/*background-image: url('../assets/background/home-news-bg.jpg');*/
background-size: cover;
background-position: center;
background-repeat: no-repeat;

}

.w-item-h{
  height: 100vh;
}

.hide-logo{
  opacity: 0;
}

.topmnu-btn-xs{
  font-size: 12px;
}

.btn-round-border{
  border: 0px solid #000;
}
.bottom-slide{
  height: 15%;
}
.full-screen{
  width:100%;
  height: 100vh;
}
/* .dwnlayer-slider{
  position: absolute;
  bottom: 0;
  left: 0;
} */
.uplayer-slider{
  position: absolute;
  top: 0;
  left: 0;
}

.text-underline{
  text-decoration: underline;
}

.slide-home{
  width: 100%;
  height: 100vh;
  
}
.bg-contacts{
  background: url('../assets/background/night.jpg') no-repeat center;
  background-size: cover;
  background-color: transparent;
}

.transparent{
  background-color: transparent;
}
.col-fade{
  position: relative;
}
.fade{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #0009;
}
.bottom-addres{
  height: 400px;
}
.fill-height-2{
  height: 88%;
}

.height-screen{
  height: 100vh;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.ymap-container {
  height: 80vh;
}
.tab-window-left{
  position: fixed;
  left: 5px;
  top: 200px;
  z-index: 1200;
  height: 200px;
}
.tab-window-right{
  position: fixed;
  right: 5px;
 /*  top: 200px; */
  height: 100vh;
  z-index: 1200;
}
.grp-tabs{
  height: 200px;

}
.top-menu-home{
  width: 100%;
  height: 15vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 300;
  background: transparent;
}

.hmt3{
  cursor: pointer;
  height: 36px;
  padding: 3px;
}
.logo-w, .point-cursor{
cursor: pointer;
}
.burger-mnu{
  font-size: 24px;
}

.btn-mnu:hover{
/* background-color: #999 !important; */
color: #fff;
border-bottom: 2px #fff solid;

}

.icons-bar{

  height: 36px;
  width: 36px;
}

.burger-mob{
  position: fixed ;
  top: 76px;
  left: 10px;
  background-color: #33333366;
}
.contact-info-md{
  font-size: 0.74rem;
}
.contact-info-lg{
  font-size: 0.82rem;
}
.w-logo{
  width: 250px;
}
.mbtpx{
  margin-bottom: 1px;
}
.find-mob-home{
  background: #FFF;
  color: #333;
}
.bg-drawer{
  backdrop-filter: blur(5px);
}
</style>
